import { render, staticRenderFns } from "./PlugKeyboardSlide.vue?vue&type=template&id=9dd7de4e&scoped=true"
import script from "./PlugKeyboardSlide.vue?vue&type=script&lang=ts"
export * from "./PlugKeyboardSlide.vue?vue&type=script&lang=ts"
import style0 from "./PlugKeyboardSlide.vue?vue&type=style&index=0&id=9dd7de4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd7de4e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerRings from 'quasar/src/components/spinner/QSpinnerRings.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpinnerRings,QLinearProgress,QBtn});
